let waitingWorker = null;
const listeners = new Set();

const announce = (worker) => {
  waitingWorker = worker;
  listeners.forEach((listener) => listener(worker));
};

export const onUpdateReady = (listener) => {
  listeners.add(listener);
  if (waitingWorker) listener(waitingWorker);
  return () => listeners.delete(listener);
};

export const watchForUpdate = (registration, container, onWaiting) => {
  if (registration.waiting && container.controller) {
    onWaiting(registration.waiting);
  }
  registration.addEventListener("updatefound", () => {
    const worker = registration.installing;
    worker?.addEventListener("statechange", () => {
      if (worker.state === "installed" && container.controller) {
        onWaiting(worker);
      }
    });
  });
};

const reloadPage = () => window.location.reload();

export const applyUpdate = (
  worker = waitingWorker,
  container = navigator.serviceWorker,
  reload = reloadPage,
) => {
  if (!worker) return;
  if (worker.state === "activated") {
    reload();
    return;
  }
  container.addEventListener("controllerchange", () => reload(), {
    once: true,
  });
  worker.postMessage({ type: "SKIP_WAITING" });
};

const checkForUpdateWhenVisible = (registration) =>
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      registration.update().catch(() => {});
    }
  });

const register = () =>
  navigator.serviceWorker
    .register(`${process.env.PUBLIC_URL}/service-worker.js`)
    .then((registration) => {
      watchForUpdate(registration, navigator.serviceWorker, announce);
      checkForUpdateWhenVisible(registration);
    })
    .catch((error) => console.error(error));

export const registerServiceWorker = () => {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;
  if (document.readyState === "complete") register();
  else window.addEventListener("load", register, { once: true });
};
